import React, { FunctionComponent } from "react";
import {
  useLocation,
  useParams
} from "react-router-dom";
import DefaultLayout from "layouts/Default";
import "./index.scss";
import ContentPageProvider from "components/content/ContentPageProvider";
import Banner from "../../components/banner";
import BookingEnquiryForm from "components/bookings/BookingEnquiryForm";
import TitleText from "../../components/titleText";

interface ParamTypes {
  name: string;
}

export const BasicTemplate: FunctionComponent = () => {
  
  let location = useLocation();
  const { name } = useParams<ParamTypes>();

    return (
      <DefaultLayout id={`basic-template-${name}`}>
        <ContentPageProvider url={location.pathname}>
          <Banner />
          <BookingEnquiryForm />
          <TitleText code="titleText" />
        </ContentPageProvider>
      </DefaultLayout>
    );
}

export default BasicTemplate;
